function _(n,t,r){var e=n(113),o=function(n){function t(t){return n.call(this,t)||this}return e.__extends(t,n),t}(n(166).Model);r.LayoutProvider=o,o.__name__="LayoutProvider"}
//# sourceMappingURL=layout_provider.min.js.map